import { Injectable } from '@angular/core';

/**
 * La clave para identificar el token en el SessionStorage
 */
const TOKEN_SESIONSTORAGE_KEY = 'jwtToken';

@Injectable()
export class JwtService {

  /**
   * Determina si el token ha sido almacenado
   */
  isTokenPresent() {
    return sessionStorage.getItem(TOKEN_SESIONSTORAGE_KEY) != null;
  }

  /**
   * Si el token esta presente, lo retorna, sino devuelve null
   */
  getToken(): string {
    if (this.isTokenPresent()) {
      return sessionStorage.getItem(TOKEN_SESIONSTORAGE_KEY);
    }
    return null;
  }

  /**
    * Almacena el token en el SessionStorage
    */
  setToken(token) {
    sessionStorage.setItem(TOKEN_SESIONSTORAGE_KEY, token);
  }

  /**
   * Remueve el token del SessionStorage
   */
  removeToken() {
    sessionStorage.removeItem(TOKEN_SESIONSTORAGE_KEY);
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/jwt.service.ts